export enum FeatureToggle {
  ConfigurableProducts = 'rt_configurable_products',
}
